export default __webpack_public_path__ + "static/media/salaryAdvanceIMG.fa5ae66f.png";